import SearchIcon from 'assets/svgr-icons/Search.svg'

import * as Styled from './styled'
interface IProps {
  isStaticView: boolean
  handleSearch: () => void
}
export const InputSearchButton: React.FC<IProps> = props => {
  const { isStaticView, handleSearch } = props
  return (
    <Styled.SearchIcon $isStaticView={isStaticView} onClick={handleSearch}>
      <SearchIcon />
    </Styled.SearchIcon>
  )
}
